import * as Yup from 'yup'

import {
  atLeastOneLowercaseCharacterRegex,
  atLeastOneNumberRegex,
  atLeastOneUppercaseCharacterRegex,
  emailRegex,
} from '../regex'
import { isEmailAlreadyRegisteredDebounced } from './Email'

export const profileShape = {
  firstName: Yup.string().trim(),
  lastName: Yup.string().trim(),
  password: Yup.string()
    .trim()
    .required('Password is required')
    .min(12, 'Password must be at least 12 characters')
    .matches(
      atLeastOneLowercaseCharacterRegex,
      'Password must contain at least one lowercase character'
    )
    .matches(
      atLeastOneUppercaseCharacterRegex,
      'Password must contain at least one uppercase character'
    )
    .matches(
      atLeastOneNumberRegex,
      'Password must contain at least one number'
    ),
  acceptTerms: Yup.bool().oneOf(
    [true],
    'Please, accept Terms of Use and Privacy Policy'
  ),
}

export const emailShape = {
  email: Yup.string()
    .trim()
    .required('Email is required')
    .test({
      name: 'isEmailAllowed',
      test: async email => {
        const emailSchema = Yup.string()
          .trim()
          .matches(emailRegex, 'Email is invalid')
        const isEmailValid = await emailSchema.isValid(email)
        if (!email || !isEmailValid) {
          return new Yup.ValidationError('Email is invalid', false, 'email')
        }

        try {
          await new Promise((resolve, reject) =>
            isEmailAlreadyRegisteredDebounced(email, resolve, reject)
          )

          return true
        } catch (error) {
          return new Yup.ValidationError(error as string, false, 'email')
        }
      },
    }),
}
